import { DefaultUrlSerializer, UrlTree } from '@angular/router';

export class CustomUrlSerializer extends DefaultUrlSerializer {
    parse(url: string): UrlTree {
        // split at ? or # while keeping the delimiter attached to the next part
        const [path, ...rest] = url.split(/(?=[?#])/);
        return super.parse(path.toLowerCase() + rest.join(''));
    }
}
